import { extractCommentText } from '@maxus/common'

import { trpcClient } from '../trpc'
import type { BridgeReviewComment } from './resolve-bridge'

type Comment = Awaited<ReturnType<typeof trpcClient.project.comments.list.query>>['items'][number]

export const toBridgeSyncComments = (comments: Comment[]): BridgeReviewComment[] => {
  const repliesByRoot = new Map<string, Comment[]>()
  for (const comment of comments) {
    if (!comment.topCommentId) continue
    const replies = repliesByRoot.get(comment.topCommentId)
    if (replies) replies.push(comment)
    else repliesByRoot.set(comment.topCommentId, [comment])
  }

  return comments
    .filter(comment => !comment.topCommentId)
    .map(comment => ({
      id: comment.id,
      is_resolved: comment.status === 'resolved',
      target_time_start: comment.startAt ?? 0,
      target_time_end: comment.endAt,
      content: [extractCommentText(comment.content)],
      reply_list: (repliesByRoot.get(comment.id) ?? []).map(reply => ({
        id: reply.id,
        content: extractCommentText(reply.content),
        created_at: new Date(reply.createdAt).getTime(),
        created_by: {
          name: reply.creator.name,
          avatar_src: reply.creator.avatarUrl ?? '',
        },
      })),
      created_at: new Date(comment.createdAt).getTime(),
      created_by: {
        name: comment.creator.name,
        avatar_src: comment.creator.avatarUrl ?? '',
      },
    }))
}
